// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackage_AddOptionsPageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type PlanPackage_AddOptionsPageQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, name: string, allowsLocations: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, code: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | null | undefined }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string } | null | undefined, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string } }, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, name: string, location: { __typename?: 'Location', id: string } }> } };

export type PlanPackage_SaveReadyPlanOptionsMutationVariables = Types.Exact<{
  input: Types.SavePlanPackageInput;
}>;


export type PlanPackage_SaveReadyPlanOptionsMutation = { __typename?: 'Mutation', savePlanPackage: { __typename?: 'SavePlanPackageResult', planPackage: { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, readyPlan: { __typename?: 'ReadyPlan', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }, type: { __typename?: 'GlobalOptionType', id: string, name: string, allowsLocations: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, code: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | null | undefined }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string } | null | undefined, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string } }, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } } };

export type PlanPackage_SaveReadyPlanOptionsFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, readyPlan: { __typename?: 'ReadyPlan', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }, type: { __typename?: 'GlobalOptionType', id: string, name: string, allowsLocations: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, code: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | null | undefined }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string } | null | undefined, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string } }, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type PlanPackage_AddReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, name: string, allowsLocations: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, code: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | null | undefined }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string } | null | undefined, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string } }, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type PlanPackage_ReadyPlanOptionGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string } };

export const PlanPackage_ReadyPlanOptionGroupFragmentDoc = gql`
    fragment PlanPackage_ReadyPlanOptionGroup on ReadyPlanOptionGroup {
  id
  name
  isMultiOptionGroup
  isSingleOptionGroup
  order
  group {
    id
    name
  }
}
    `;
export const PlanPackage_AddReadyPlanOptionFragmentDoc = gql`
    fragment PlanPackage_AddReadyPlanOption on ReadyPlanOption {
  id
  name
  displayName
  active
  type {
    id
    name
    allowsLocations
  }
  globalOption {
    id
    code
    readyPlan {
      id
      name
    }
  }
  readyPlanLocation {
    id
  }
  optionGroup {
    ...PlanPackage_ReadyPlanOptionGroup
  }
  optionPrerequisites {
    id
  }
  optionConflicts {
    id
  }
  optionConflictChildren {
    id
  }
  optionPrereqChildren {
    id
  }
  order
  canDelete {
    ...PotentialOperationDetails
  }
}
    ${PlanPackage_ReadyPlanOptionGroupFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const PlanPackage_SaveReadyPlanOptionsFragmentDoc = gql`
    fragment PlanPackage_SaveReadyPlanOptions on ReadyPlanOption {
  ...PlanPackage_AddReadyPlanOption
  readyPlan {
    id
    options {
      id
    }
  }
}
    ${PlanPackage_AddReadyPlanOptionFragmentDoc}`;
export const PlanPackage_AddOptionsPageDocument = gql`
    query PlanPackage_AddOptionsPage($id: ID!, $versionId: ID) {
  planPackage(id: $id, versionId: $versionId) {
    id
    canEdit {
      ...PotentialOperationDetails
    }
    options {
      ...PlanPackage_AddReadyPlanOption
    }
    roomLocations(filter: {locationType: [GROUP, ROOM, LEVEL]}) {
      ...Named
      location {
        id
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${PlanPackage_AddReadyPlanOptionFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __usePlanPackage_AddOptionsPageQuery__
 *
 * To run a query within a React component, call `usePlanPackage_AddOptionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackage_AddOptionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackage_AddOptionsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackage_AddOptionsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables> & ({ variables: PlanPackage_AddOptionsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>(PlanPackage_AddOptionsPageDocument, options);
      }
export function usePlanPackage_AddOptionsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>(PlanPackage_AddOptionsPageDocument, options);
        }
// @ts-ignore
export function usePlanPackage_AddOptionsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>;
export function usePlanPackage_AddOptionsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackage_AddOptionsPageQuery | undefined, PlanPackage_AddOptionsPageQueryVariables>;
export function usePlanPackage_AddOptionsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>(PlanPackage_AddOptionsPageDocument, options);
        }
export type PlanPackage_AddOptionsPageQueryHookResult = ReturnType<typeof usePlanPackage_AddOptionsPageQuery>;
export type PlanPackage_AddOptionsPageLazyQueryHookResult = ReturnType<typeof usePlanPackage_AddOptionsPageLazyQuery>;
export type PlanPackage_AddOptionsPageSuspenseQueryHookResult = ReturnType<typeof usePlanPackage_AddOptionsPageSuspenseQuery>;
export type PlanPackage_AddOptionsPageQueryResult = ApolloReactCommon.QueryResult<PlanPackage_AddOptionsPageQuery, PlanPackage_AddOptionsPageQueryVariables>;
export const PlanPackage_SaveReadyPlanOptionsDocument = gql`
    mutation PlanPackage_SaveReadyPlanOptions($input: SavePlanPackageInput!) {
  savePlanPackage(input: $input) {
    planPackage {
      id
      version {
        id
      }
      options {
        ...PlanPackage_SaveReadyPlanOptions
      }
    }
  }
}
    ${PlanPackage_SaveReadyPlanOptionsFragmentDoc}`;

/**
 * __usePlanPackage_SaveReadyPlanOptionsMutation__
 *
 * To run a mutation, you first call `usePlanPackage_SaveReadyPlanOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanPackage_SaveReadyPlanOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planPackageSaveReadyPlanOptionsMutation, { data, loading, error }] = usePlanPackage_SaveReadyPlanOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanPackage_SaveReadyPlanOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PlanPackage_SaveReadyPlanOptionsMutation, PlanPackage_SaveReadyPlanOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PlanPackage_SaveReadyPlanOptionsMutation, PlanPackage_SaveReadyPlanOptionsMutationVariables>(PlanPackage_SaveReadyPlanOptionsDocument, options);
      }
export type PlanPackage_SaveReadyPlanOptionsMutationHookResult = ReturnType<typeof usePlanPackage_SaveReadyPlanOptionsMutation>;
export type PlanPackage_SaveReadyPlanOptionsMutationResult = ApolloReactCommon.MutationResult<PlanPackage_SaveReadyPlanOptionsMutation>;